export default __webpack_public_path__ + "static/Dorman-73e70914523cb4fd04c9001fbe157fce.jpg";